import { useState } from "react";

const sections = [
  { id: "what", label: "What Makes Rolex9 Special" },
  { id: "security", label: "Security and Licence" },

  { id: "games", label: "Games & Providers" },
  { id: "sports", label: "Sports Betting" },
  { id: "bonuses", label: "Bonuses and Promotions" },
  { id: "payment", label: "Payment Methods" },
  { id: "mobile", label: "Mobile App" },
  { id: "customer", label: "Customer Support" },
  { id: "seo-content", label: "Rolex9 Insights" },
  { id: "conclusion", label: "Conclusion" },
  { id: "faq", label: "FAQ" },
];

export default function TableOfContents() {
  const [open, setOpen] = useState(true);

  return (
    <nav className="glass-card-gold rounded-2xl p-6 my-10" aria-label="Table of contents">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-1 h-5 rounded-full" style={{ background: "linear-gradient(180deg, #c9a84c, #6b21a8)" }}></div>
          <h2
            className="text-white/80 font-semibold text-sm tracking-widest uppercase"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Contents
          </h2>
        </div>
        <button
          onClick={() => setOpen(!open)}
          className="w-7 h-7 flex items-center justify-center rounded-full border border-[#c9a84c]/30 text-[#c9a84c] hover:border-[#c9a84c]/70 transition-colors cursor-pointer text-sm"
          aria-expanded={open}
          aria-controls="toc-list"
        >
          <i className={`${open ? "ri-subtract-line" : "ri-add-line"}`}></i>
        </button>
      </div>
      {open && (
        <>
          <h3 className="sr-only">On this page</h3>
          <ol id="toc-list" className="grid grid-cols-1 sm:grid-cols-2 gap-1.5">
            {sections.map((s, i) => (
              <li key={s.id}>
                <a
                  href={`#${s.id}`}
                  className="flex items-center gap-2.5 py-1.5 px-2 rounded-lg hover:bg-white/5 transition-colors group"
                >
                  <span className="text-[#c9a84c]/40 text-xs font-mono group-hover:text-[#c9a84c]/70 transition-colors">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-white/40 text-xs tracking-wide group-hover:text-white/70 transition-colors">
                    {s.label}
                  </span>
                </a>
              </li>
            ))}
          </ol>
        </>
      )}
    </nav>
  );
}
